<svg
  [attr.width]="flagWidth"
  [attr.height]="flagHeight"
  [attr.viewBox]="viewBox"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
  (click)="$event.stopPropagation(); triggerStatusClick()"
  preserveAspectRatio="xMidYMid meet">
  <rect
    x="16.4014"
    y="16.6104"
    width="15.6044"
    height="15.6044"
    rx="7.80222"
    transform="rotate(-179.23 16.4014 16.6104)"
    [attr.fill]="flagBgColor" />
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M6.625 4C6.27982 4 6 4.27982 6 4.625V13.375C6 13.7202 6.27982 14 6.625 14C6.97018 14 7.25 13.7202 7.25 13.375V4.625C7.25 4.27982 6.97018 4 6.625 4ZM9.00725 11.0456L14.5 7.74999L9.00725 4.45435C8.67399 4.25439 8.25 4.49445 8.25 4.88309L8.25 10.6169C8.25 11.0056 8.67399 11.2456 9.00725 11.0456Z"
    [attr.fill]="flagFillColor" />
</svg>
